module.exports = __webpack_public_path__ + "img/sweater.8c78482a.svg";